export var eventClickMock = {
    success: null,
    errorBadRequest: { type: 'RESPONSE_400_BAD_REQUEST' },
    errorInternalError: { type: 'RESPONSE_500_INTERNAL_SERVER_ERROR' },
};
